import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { HolidayCalendarHeaderRow, HolidayCalendarRow } from 'components/Calendar'
import { getCalendarArray } from 'lib/calendar'
import { endOfMonth, startOfMonth } from 'date-fns'

type Props = {
  activeDates: Date[]
  currentMonth: Date
  selectDate: (date: Date) => void
}

const HolidayCalendar: FC<Props> = (props) => {
  const { activeDates, currentMonth, selectDate } = props
  const calendar = getCalendarArray(startOfMonth(currentMonth), endOfMonth(currentMonth))

  return (
    <>
      <table className={styles.table}>
        <thead>
          <HolidayCalendarHeaderRow />
        </thead>
        <tbody>
          {calendar.map((row, rowNum) => (
            <HolidayCalendarRow
              key={rowNum}
              activeDates={activeDates}
              currentMonth={currentMonth}
              row={row}
              selectDate={selectDate}
            />
          ))}
        </tbody>
      </table>
    </>
  )
}

export default HolidayCalendar
